const SalesData = [
  {
    status: "To Be Packed",
    value: 228,
    type: "Qty",
    color: "text-blue-500",
  },
  {
    status: "To be Shipped",
    value: "6",
    type: "Pkgs",
    color: "text-red-500",
  },
  {
    status: "To be delivered",
    value: "10",
    type: "Pkgs",
    color: "text-green-500",
  },
  {
    status: "To be invoiced",
    value: "474",
    type: "Qty",
    color: "text-blue-500",
  },
];
export default SalesData;
